import { NUMBER, STRING } from '../../../utils/component-validations';
import { getDefaultValueFromMetadata } from '../../../utils/spds/metadata';
import { reads } from 'macro-decorators';
import Container from './container.gjs';
import Super from './base.gjs';
import styles from './character-counter.module.scss';

const METADATA = {
  component: 'Spds::Core::CharacterCounter',
  description:
    'The character counter actively displays the ratio of characters used and the total character limit. The character counter should appear on the bottom right of our text inputs',
  meta: {
    limit: {
      description: 'The maximum number of characters allowed',
      initialValue: 200,
      required: true,
      type: NUMBER,
    },
    value: {
      defaultValue: '',
      description: 'The current value to count characters from',
      initialValue: 'Lorem ipsum dolor sit amet',
      type: STRING,
    },
  },
  name: 'Character Counter',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/blob/staging/addon/src/components/spds/core/character-counter.gjs',
    zeroheight:
      'https://www.simplepractice.design/1d0abbc0a/p/471adb-text-inputs/t/page-471adb-68575769-9',
  },
};

export default class SpdsCoreCharacterCounter extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-text-input-character-counter';
  classesToMapToAttrs = ['over'];
  componentName = 'Spds::Core::CharacterCounter';
  styles = styles;

  @reads('value.length', 0) charCount;

  get over() {
    return this.charCount > this.args.limit;
  }

  get value() {
    return this.args.value ?? getDefaultValueFromMetadata(this.constructor.metadata, 'value');
  }

  <template>
    <Container
      @fitContent={{true}}
      class={{this.classes}}
      data-test-spds-character-counter
      {{this.validateArguments}}
      ...attributes
    >
      {{this.charCount}}/{{@limit}}
    </Container>
  </template>
}

export const SPDS_CORE_CHARACTER_COUNTER_METADATA = SpdsCoreCharacterCounter.metadata;
